module.exports = __webpack_public_path__ + "media/images/shop-9615fc4ced063596c4dd6f4db06dd41f.png";